// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ClientNavigation_wrapper__2OULo"};